import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpStatusCode
} from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CallerService } from '../services/caller.service';
import { AdminService } from '../services/admin.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorResponseInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private callerService: CallerService,
    private adminService: AdminService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // return next.handle(request);

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Ignore if it's from login or sign up
        if ((request.url.endsWith('/login') || request.url.endsWith('/signup')) && request.method === "POST") {
          return next.handle(request);
        }

        // Admin requests hit /admin/* and fail auth with either 401 (expired/invalid token)
        // or 403 (missing/invalid X-Admin-Key) - both mean the admin session is no longer valid.
        const isAdminRequest = request.url.includes('/admin/')
        const isAuthFailure = error.status === HttpStatusCode.Unauthorized
          || (isAdminRequest && error.status === HttpStatusCode.Forbidden)

        if (isAuthFailure) {
          this.callerService.closeAllModals()

          if (isAdminRequest) {
            this.adminService.showNotification("Admin session expired. Please log in again.", 5000, "OK")
            this.adminService.logout()
          } else {
            // route to login
            this.callerService.showNotification("Unauthorized. Please login to continue.", 5000, "OK" , "bottom")
            this.callerService.logout({ returnHere: true }); // an expired session: back to this page after logging in
          }

          return EMPTY // stop request.
        }

        return throwError(error); // need it for method response type (TS)
      })
    );
  }
}
